module.exports = __webpack_public_path__ + "img/icon_map_51_off_101.4c1491e8.png";